export default "__VITE_ASSET__CU75qiec__"